<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="1200px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="100px"
      :rules="formRules"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="贴膜门店:" prop="Tenant">
            <tenantSelector
              ref="tenantSelector"
              v-model="dataForm.Tenant"
              @change="tenantChanged"
              :disabled="readOnly"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接单人员:" prop="Creator">
            <memberSelector
              ref="creatorSelector"
              :disabled="readOnly"
              v-model="dataForm.Creator"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="施工人员:" prop="Operator">
            <el-input
              v-model="dataForm.Operator"
              auto-complete="off"
              placeholder="请输入施工人员"
              :disabled="readOnly"
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="合作单位:" prop="Cooperate">
            <cooperateSelector
              ref="cooperateSelector"
              :tenant="dataForm.Tenant.Key"
              v-model="dataForm.Cooperate"
              :disabled="readOnly"
              @change="coopChanged"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-card hadow="never">
        <div slot="header">
          <span>客户</span>
          <div v-if="!readOnly" style="float: right; display: flex">
            <el-tag type="success">老客户请从系统选择：</el-tag>
            <customerSelector
              ref="customerSelector"
              v-model="dataForm.Customer"
              @change="customerChanged"
            />
          </div>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车主姓名：" prop="Customer.Name">
              <el-input
                v-model="dataForm.Customer.Name"
                size="small"
                auto-complete="off"
                :disabled="readOnly"
                placeholder="请输入车主姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车主电话：" prop="Customer.Mobile">
              <el-input
                v-model="dataForm.Customer.Mobile"
                auto-complete="off"
                placeholder="请输入车主电话"
                size="small"
                :disabled="readOnly"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车辆类型：" prop="Customer.CarModel">
              <el-input
                v-model="dataForm.Customer.CarModel"
                auto-complete="off"
                placeholder="请输入车辆类型"
                size="small"
                :disabled="readOnly"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车架号VIN" prop="Customer.VIN">
              <el-input
                v-model="dataForm.Customer.VIN"
                auto-complete="off"
                placeholder="请输入车架号VIN"
                size="small"
                :disabled="readOnly"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车牌号" prop="Customer.CarNo">
              <el-input
                v-model="dataForm.Customer.CarNo"
                size="small"
                auto-complete="off"
                placeholder="请输入车牌号"
                :disabled="readOnly"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>
      </el-card>
      <el-card hadow="never" style="margin-top: 10px">
        <div slot="header">
          <div
            v-if="!readOnly"
            style="
              display: flex;
              flex-direction: row;
              justify-items: center;
              justify-content: space-between;
            "
          >
            <!-- <productSelector ref="productSelector" v-model="selProduct" /> -->
            <productStockSelector
              ref="productStockSelector"
              v-model="selProduct"
              :shop="dataForm.Tenant.Key"
            />
            <el-button
              class="submit-btn"
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addProduct"
              >添加商品</el-button
            >
          </div>
          <div v-else>产品详情</div>
        </div>
        <el-table
          size="mini"
          stripe
          border
          :data="dataForm.Details.Items"
          highlight-current-row
          expand-on-click-node="false"
          style="width: 100%"
        >
          <el-table-column
            prop="Product.Name"
            label="商品名称"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="Product.ProductType.Name"
            label="商品类型"
            min-width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag type="danger">{{
                scope.row.Product.ProductType.Name
              }}</el-tag>
              <el-tag type="success">
                {{ scope.row.Product.ProductSet.Name }}
              </el-tag>
              <el-tag>
                {{ scope.row.Product.Specical }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="UsingPlace" label="贴膜区域" min-width="150">
            <template slot-scope="scope">
              {{ format.usingPlaceFormat(scope.row.UsingPlace) }}
            </template>
          </el-table-column>
          <el-table-column prop="TradeCount" label="数量" width="160">
            <template slot-scope="scope">
              <el-input-number
                size="small"
                :min="0"
                :disabled="readOnly"
                :precision="2"
                @change="calcDetail(scope.row)"
                v-model="scope.row.TradeCount"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="MarketPrice" label="市场价" width="90">
            <template slot-scope="scope">
              <el-tag type="danger">
                {{ scope.row.MarketPrice }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="TradePrice" label="成交价" width="160">
            <template slot-scope="scope">
              <el-input-number
                size="small"
                @change="calcuAmount"
                :precision="2"
                :disabled="readOnly"
                :min="0"
                v-model="scope.row.TradePrice"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="TradePrice" label="" width="55">
            <template slot-scope="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                circle
                @click="handleRemove(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 15px">
          <el-col :span="16">
            <el-form-item label="横向产品：" prop="SaleOtherProduct">
              <el-input
                v-model="dataForm.SaleOtherProduct"
                style="width: 100%"
                :disabled="readOnly"
                size="small"
                auto-complete="off"
                placeholder="请输入其他销售产品"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="横向金额：" prop="SaleOtherAmount">
              <el-input-number
                v-model="dataForm.SaleOtherAmount"
                style="width: 100%"
                :disabled="readOnly"
                :precision="2"
                size="small"
                auto-complete="off"
                :min="0"
                @change="calcuAmount"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-col :span="24">
            <el-form-item label="备注：" prop="Description">
              <el-input
                type="textarea"
                v-model="dataForm.Description"
                style="width: 100%"
                :disabled="readOnly"
                size="small"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card hadow="never" style="margin-top: 10px">
        <div slot="header">
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
          >
            <el-form-item label="应收：">
              <el-tag type="info" style="font-weight: bold; font-size: 14px">{{
                dataForm.TradeAmount - 0
              }}</el-tag>
            </el-form-item>
            <el-form-item label="挂账：">
              <el-tag
                type="danger"
                style="font-weight: bold; font-size: 14px"
                >{{ dataForm.DebtAmount }}</el-tag
              >
            </el-form-item>
            <el-form-item label="已收：">
              <el-tag
                type="success"
                style="font-weight: bold; font-size: 14px"
                >{{ dataForm.TradeAmount - dataForm.DebtAmount }}</el-tag
              >
            </el-form-item>
            <el-form-item label="收银：" prop="Casher">
              <memberSelector
                ref="casherSelector"
                :disabled="readOnly"
                v-model="dataForm.Casher"
              />
            </el-form-item>
          </div>
        </div>
        <el-row>
          <el-col :span="6">
            <el-form-item label="微信：" prop="WxPayAmount">
              <el-input-number
                v-model="dataForm.WxPayAmount"
                style="width: 100%"
                :precision="2"
                :min="0"
                size="small"
                auto-complete="off"
                :disabled="readOnly"
                placeholder=""
                @change="calcuAmount"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付宝：" prop="ZfbPayAmount">
              <el-input-number
                v-model="dataForm.ZfbPayAmount"
                style="width: 100%"
                :precision="2"
                :min="0"
                size="small"
                auto-complete="off"
                :disabled="readOnly"
                placeholder=""
                @change="calcuAmount"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="银行卡：" prop="BankPayAmount">
              <el-input-number
                v-model="dataForm.BankPayAmount"
                style="width: 100%"
                :precision="2"
                size="small"
                :min="0"
                :disabled="readOnly"
                auto-complete="off"
                placeholder=""
                @change="calcuAmount"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="现金：" prop="CashPayAmount">
              <el-input-number
                v-model="dataForm.CashPayAmount"
                @change="calcuAmount"
                style="width: 100%"
                :precision="2"
                :min="0"
                :disabled="readOnly"
                size="small"
                auto-complete="off"
                placeholder=""
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-form-item
        style="margin-top: 20px; text-align: center"
        v-if="!readOnly"
      >
        <el-button
          style="width: 200px"
          type="success"
          @click="handleSubmit(false)"
          >保存订单</el-button
        >
        <el-button style="width: 200px" type="info" @click="handleClose(false)"
          >关闭（不保存）</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { save, getSingle } from "@/api/bussiness/order";
import tenantSelector from "@/components/tenantSelector.vue";
import workerSelector from "@/components/workerSelector.vue";
import memberSelector from "@/components/memberSelector.vue";
import productSelector from "@/components/productSelector.vue";
import productStockSelector from "@/components/productStockSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
export default {
  components: {
    enumSelector2,
    tenantSelector,
    workerSelector,
    memberSelector,
    productSelector,
    productStockSelector,
  },
  data() {
    return {
      TenantKey: localStorage.getItem("X-TenantKey"),
      UserKey: localStorage.getItem("X-UserKey"),
      readOnly: false,
      selProduct: "",
      selPlaces: 2,
      dataForm: {
        Tenant: { Key: "" },
        Cooperate: { Key: "" },
        Creator: { Key: this.UserKey },
        Customer: {
          Name: "",
          Mobile: "",
          CarModel: "",
          VIN: "",
          CarNo: "",
        },
        Details: {
          ItemType: "LxApp.Data.OrderDetail",
          Items: [],
        },
        WxPayAmount: 0,
        ZfbPayAmount: 0,
        BankPayAmount: 0,
        CashPayAmount: 0,
        MarketAmount: 0,
        TradeAmount: 0,
        DebtAmount: 0,
      },
      drawerTitle: "",
      drawerVisible: false,
      formRules: {
        Tenant: [{ required: true, message: "请选择门店", trigger: "change" }],
        Creator: [
          { required: true, message: "请选择开单人", trigger: "change" },
        ],
        Cooperate: [
          { required: true, message: "请选择合作单位", trigger: "change" },
        ],
        Saler: [
          { required: true, message: "请选择销售顾问", trigger: "change" },
        ],
        Operator: [
          { required: true, message: "请输入施工人", trigger: "change" },
        ],
        "Customer.Name": [
          { required: true, message: "请输入车主姓名", trigger: "change" },
        ],
        "Customer.Mobile": [
          { required: true, message: "请输入车主电话", trigger: "change" },
        ],
        "Customer.CarModel": [
          { required: true, message: "请输入车辆类型", trigger: "change" },
        ],
        "Customer.CarNo": [
          { required: true, message: "请输入车牌号", trigger: "change" },
        ],
        "Customer.VIN": [
          { required: true, message: "请输入车架号", trigger: "change" },
        ],
        Casher: [
          { required: true, message: "请选择收银员", trigger: "change" },
        ],

        WxPayAmount: [{ required: true, message: "请输入", trigger: "change" }],
        ZfbPayAmount: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        BankPayAmount: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        CashPayAmount: [
          { required: true, message: "请输入", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    handleAddNewSale()
    {
    },
    updateSales()
    {
    },
    tenantChanged(v) {
     if(!v)
     {
        this.dataForm.Tenant={Key:""};
        this.dataForm.Cooperate ="";
     }
    },
    coopChanged(v)
    {
      if(!v)
      {
        this.dataForm.Cooperate={Key:""};
        this.dataForm.Saler ="";
      }
    },
    calcDetail(row) {
      row.MarketPrice = row.TradeCount * row.Product.SalePrice;
    },
    calcuAmount(v) {
      let trade = 0;
      this.dataForm.Details.Items.forEach((r) => {
        trade += r.TradePrice;
      });
      trade = trade + this.dataForm.SaleOtherAmount;
      this.dataForm.TradeAmount = trade;
      let payAmount =
        this.dataForm.WxPayAmount +
        this.dataForm.ZfbPayAmount +
        this.dataForm.BankPayAmount +
        this.dataForm.CashPayAmount;
      this.dataForm.DebtAmount = this.dataForm.TradeAmount - payAmount;
    },
    customerChanged(v) {
      if (!v) {
        this.dataForm.Customer = {
          Name: "",
          Mobile: "",
          CarModel: "",
          VIN: "",
          CarNo: "",
        };
      }
    },
    handleView(row) {
      this.drawerTitle = "查看订单";
      this.drawerVisible = true;
      this.readOnly = true;
      let param = { key: row.Key };
      let that = this;
      getSingle(param).then((response) => {
        if (response) {
          that.dataForm = response;
        }
      });
    },
    initForm() {
      this.dataForm = {
        Tenant: { Key: this.TenantKey },
        Cooperate: { Key: "" },
        Creator: { Key: this.UserKey },
        Customer: {
          Name: "",
          Mobile: "",
          CarModel: "",
          VIN: "",
          CarNo: "",
        },
        Details: {
          ItemType: "LxApp.Data.OrderDetail",
          Items: [],
        },
        SaleOtherProduct: "",
        SaleOtherAmount: 0,
        WxPayAmount: 0,
        ZfbPayAmount: 0,
        BankPayAmount: 0,
        CashPayAmount: 0,
        MarketAmount: 0,
        TradeAmount: 0,
        DebtAmount: 0,
      };
    },
    addProduct() {
      if (!this.selPlaces) {
        this.msg.errorMsg("请选择贴膜位置！");
        return;
      }
      if (!this.selProduct) {
        this.msg.errorMsg("请选择贴膜商品！");
        return;
      }
      let exist = this.dataForm.Details.Items.find(
        (r) => r.Product.Key == this.selProduct.Key
      );
      if (exist) {
        this.msg.errorMsg("该产品已添加，请勿重复添加");
        return;
      }
      let item = {
        Product: this.selProduct,
        TradeCount: 1,
        MarketPrice: this.selProduct.SalePrice * 1,
        TradePrice: this.selProduct.SalePrice * 1,
        UsingPlace: this.selPlaces,
      };
      this.dataForm.Details.Items.push(item);
      this.calcuAmount();
    },
    handleRemove(row) {
      const index = this.dataForm.Details.Items.indexOf(row);
      if (index >= 0) {
        this.dataForm.Details.Items.splice(index, 1);
      }
    },
    handleCreate() {
      this.drawerTitle = "创建订单";
      this.drawerVisible = true;
      this.readOnly = false;
      this.initForm();
    },
    handleSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let para = Object.assign(this.dataForm);
          save(para).then((response) => {
            if (response) {
              this.drawerVisible = false;
              this.msg.successMsg("保存成功！");
              this.$emit("update");
            }
          });
        }
      });
    },
    handleClose() {
      this.drawerVisible = false;
      this.initForm();
    },
    handleUpdate(row) {
      let param = { key: row.Key };
      let that = this;
      this.readOnly = false;
      getSingle(param).then((response) => {
        if (response) {
          that.dataForm = response;
          that.drawerTitle = "修改订单";
          that.drawerVisible = true;
        }
      });
    },
  },
  mounted() {},
};
</script>
<style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>